<template>
    <div>
        <button v-if="!audioEnabled" @click="enableAudio">Clique aqui para ativar o áudio</button>
        <audio ref="audio">
            <source src="@/static/bell-song.mp3" type="audio/mp3">
        </audio>
        <v-row>
            <v-col cols="12">                
                <v-card height='470px'>
                    <v-layout column>
                        <h4 v-if="NomePaciente" class="primary--text text-center font-weight-bold mt-10" style="font-size:100px">
                            {{ NomePaciente }}
                        </h4>
                        <h4 v-else class="primary--text text-center font-weight-bold mt-5" style="font-size:200px">
                            {{ Senha }}
                        </h4>
                        <h4 class="primary--text text-center font-weight-bold mt-5" style="font-size:70px">
                            {{ Local }}
                        </h4>                                
                    </v-layout>                    
                </v-card>
            </v-col>            
        </v-row>
        <v-row>
            <v-img style="margin: auto auto;"
                aspect-ratio="3"
                max-width="180px"
                src="../assets/sesi-logo.png"
                @click="reloadPage"
            ></v-img>            
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card  height='430' style="overflow-y:auto">
                    <h4 class="primary--text font-weight-bold pt-5" style="text-align: center !important">
                        ÚLTIMAS SENHAS CHAMADAS
                    </h4>
                    <v-data-table
                    :headers="headersSenhasChamadas"
                    :items="senhasChamadasList"
                    itemsPerRow="6"
                    class="chamadas"
                    >
                        <template v-slot:[`item.Senha`]=" { item } ">
                            <span class="primary--text" style="font-size: 2rem"> {{item.Senha}} </span>
                        </template>

                        <template v-slot:[`item.Nome`]=" { item } ">
                            <span class="primary--text" style="font-size: 3rem"> {{item.Nome}} </span>
                        </template>

                        <template v-slot:[`item.Local`]=" { item } "> 
                            <span class="primary--text" style="font-size: 2rem"> {{item.Local}} </span>
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
            <a href="javascript:void(0);" @click="reloadPage" style="margin: auto;">Atualizar</a>
        </v-row>        
    </div>
</template>

<script>
 
import { delay } from '@/utils/delay.js'
import NoSleep from 'nosleep.js';
var noSleep = new NoSleep();
noSleep.enable();

export default {
    watch: {
        init: {
            immediate: true,
            handler() {
                this.getUltimaFicha()
                this.getSenhasChamadas()                
            }
        }
    },
    data() {        
        return {
            audioEnabled: false,
            senhasChamadasList:[],
            tocarBeep: null,
            NomePaciente: null,
            Local: null,            
            Senha: null,
            id: null,
            headersSenhasChamadas:[
                    {text:'Número da senha', value:'Senha', width:"10%", font:"40px", align:"center"},
                    {text:'Nome do paciente', value:'Nome', width:"50%", align:"left"},
                    {text:'Local', value:'Local', width:"20%", align:"center"},
                ],
            reload: null
        }
    },
    methods: { 
        enableAudio() {
            this.audioEnabled = true;
            // Tenta reproduzir para destravar a permissão
            this.$refs.audio.play().catch();
        },       
        reloadPage() {
            location.reload(true); // Recarrega a página
        },
        async getSenhasChamadas(){
            const { data } = await this.axios.get('painel/listarSenhas', { params: { id: this.$route.query.id } })
            this.senhasChamadasList = data
            setTimeout(this.getSenhasChamadas, 15000)
        },
        falarNome(nome){
            let msg = new SpeechSynthesisUtterance();
            msg.text = nome;
            window.speechSynthesis.speak(msg);
        },
        async getUltimaFicha(){
			const { data } = await this.axios.get('painel/ultimaSenhaChamada', { params: { id: this.$route.query.id } })
            data.forEach(element => {
                    this.Senha          = element.Senha
                    this.NomePaciente   = element.Nome
                    this.Local          = element.Local
                    this.tocarBeep      = element.tocarBeep
            })

            if (this.tocarBeep) {
                this.$refs.audio.play()
                delay(1000);
                this.NomePaciente
                    ? this.falarNome(this.NomePaciente)
                    : this.falarNome('Senha ' + this.Senha)
                this.falarNome(this.Local)
            }

            setTimeout(this.getUltimaFicha, 15000);
		},        
    },
    mounted() {
        // setInterval(() => {
        //     location.reload(true);
        // }, 90000); // recarregar a pagina a cada 3 minutos

        if (navigator.wakeLock?.request) {
            navigator.wakeLock.request('screen').catch();
        }
    },
}
</script>

<style>
    .chamadas{
        size:8.4rem !important;
        color:blue;
    }
</style>